<template>
  <section class="quote-divider">
    <div class="h25-container">
      <blockquote>创势互联联合生态渠道伙伴，整合伙伴本地化行业资源与创势AI落地技术能力，面向园区、制造、政务领域终端客户，共同交付可落地、可验收的一体化AI数字化服务。</blockquote>
      <p class="attr">— 伙伴在前、创势在后，做伙伴最可靠的后端技术中台</p>
    </div>
    <div style="text-align:center;margin-top:40px"><span class="h25-btn-primary" @click="goAnchor('contact')">获取同款方案 →</span></div>
  </section>
</template>
<script>export default{name:'QuoteDivider',inject:['goAnchor']}</script>
<style scoped>
.quote-divider{padding:72px 0;text-align:center;border-top:1px solid var(--h25-border);border-bottom:1px solid var(--h25-border)}
blockquote{font-size:22px;font-weight:600;max-width:700px;margin:0 auto;color:var(--h25-text);line-height:1.7}
blockquote::before{content:'"';display:block;font-size:44px;color:var(--h25-accent);margin-bottom:10px;opacity:.5}
.attr{font-size:13px;color:var(--h25-muted);margin-top:14px}
</style>
